import { render, staticRenderFns } from "./UploadOrder.vue?vue&type=template&id=2ac51280"
import script from "./UploadOrder.vue?vue&type=script&lang=js"
export * from "./UploadOrder.vue?vue&type=script&lang=js"
import style0 from "./UploadOrder.vue?vue&type=style&index=0&id=2ac51280&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports